<template>
  <div class="home">
    <section class="intro" aria-labelledby="intro-title">
      <img
        class="intro__photo"
        src="@/assets/group-of-people.jpg"
        alt=""
        width="1200"
        height="667"
      />
      <div class="container intro__inner">
        <div class="intro__panel">
          <p class="intro__kicker">Sindicato dos Bancários de Uberlândia e Região</p>
          <h1 id="intro-title" class="intro__title">Invista em quem te defende</h1>
          <router-link :to="{ name: 'Seja sócio' }" class="btn btn--primary intro__cta">Seja sócio</router-link>
        </div>
      </div>
    </section>

    <section class="home-news" aria-labelledby="news-title">
      <div class="container">
        <div class="section-head">
          <h2 id="news-title" class="news-title">Últimas notícias</h2>
        </div>
        <news-home />
      </div>
    </section>

    <encounters-home />

    <section class="home-partners" aria-labelledby="partners-title">
      <div class="container">
        <div class="section-head">
          <h2 id="partners-title" class="section-title">Sindicatos parceiros</h2>
        </div>
        <affiliates-home />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {
    NewsHome: () => import("@/layouts/web/home/NewsHome.vue"),
    EncountersHome: () => import("@/layouts/web/home/EncountersHome.vue"),
    AffiliatesHome: () => import("@/layouts/web/home/AffiliatesHome.vue"),
  },
  metaInfo: {
    title: "SEEB | Home",
    meta: [
      { name: "description", content: "Todas as informações do sindicato dos bancários de Uberlândia." },
    ],
  },
  props: {
    id: {
      type: String,
      default: "home",
    },
  },
};
</script>

<style lang="scss" scoped>
// Abertura: foto de pessoas em faixa larga, com um painel navy que carrega o título.
// Altura moderada para não competir com as notícias logo abaixo.
.intro {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 340px;
  overflow: hidden;
  background: var(--c-navy);

  &__photo {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 60% 35%;
  }

  // Véu que escurece a esquerda, onde fica o texto, e deixa a foto respirar à direita.
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(36, 50, 75, 0.94) 0%, rgba(36, 50, 75, 0.7) 45%, rgba(36, 50, 75, 0.12) 100%);
  }

  &__inner {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    padding-top: clamp(40px, 5vw, 64px);
    padding-bottom: clamp(40px, 5vw, 64px);
  }

  &__panel {
    max-width: 520px;
  }

  &__cta {
    margin-top: 28px;
  }

  &__kicker {
    margin: 0 0 14px;
    font-size: var(--fs-small);
    font-weight: 600;
    letter-spacing: 0.01em;
    color: var(--c-on-dark);
  }

  &__title {
    margin: 0;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: clamp(34px, 4vw, 52px);
    line-height: 1.08;
    letter-spacing: -0.02em;
    color: #fff;
  }

  @media (max-width: 599px) {
    min-height: 0;

    &__photo {
      object-position: 70% 30%;
    }

    &::after {
      background: linear-gradient(180deg, rgba(36, 50, 75, 0.35) 0%, rgba(36, 50, 75, 0.94) 65%);
    }

    &__inner {
      align-items: flex-end;
      min-height: 300px;
    }
  }
}

.home-news {
  padding: clamp(40px, 4vw, 56px) 0 clamp(48px, 5vw, 72px);
}

// Título da seção de notícias: caixa-alta e barra de destaque para chamar a atenção.
.news-title {
  position: relative;
  margin: 0;
  padding-top: 18px;
  font-family: var(--font-text);
  font-size: clamp(22px, 2.4vw, 28px);
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--c-navy);
}

.news-title::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 56px;
  height: 4px;
  background: var(--c-orange);
}

.home-partners {
  padding: clamp(48px, 5vw, 72px) 0;
  background: var(--c-surface);
  border-top: 1px solid var(--c-line);
}

.section-head {
  margin-bottom: 24px;
}

@media (max-width: 599px) {
  .intro__actions {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
